export default __webpack_public_path__ + "static/product-reference-chart-desktop-f70c1df5e3b0d097bafaae72c7a619e0.png";